import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--cta",
  "use": "icon-arrow--cta-usage",
  "viewBox": "0 0 15 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 10\" id=\"icon-arrow--cta\"><g clip-path=\"url(#clip0_7_7099)\"><path d=\"M14.4 4.995 9.48.085l-.65.65 3.8 3.8H0v.92h12.63l-3.8 3.8.65.66 4.92-4.92Z\" fill=\"currentColor\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol